function GetProductStateClass(type) {
    let result = "";
    switch (type) {
      case 0:
        result = "";
        break;
      case 1:
        result = "enabled";
        break;
      case 2:
        result = "enabled";
        break;
      case 3:
        result = "suspend";
        break;
      case 4:
        result = "disabled";
        break;
      case 5:
        result = "suspend";
        break;
      default:
        result = "";
        break;
    }
    return result;
  }
export default GetProductStateClass;
